export const translations = {
  tagline: 'the best way to work with real estate online',
  errorInvalidEmail: 'You entered an invalid e-mail',
  errorRequired: 'This field is required',
  errorMin8: 'Password should consist of at least 8 characters',
  errorOnlyLatin: 'Password should consist of latin letters only',
  errorMatch: 'Passwords must match',
  email: 'Email',
  authTitle: 'Authorization',
  regSubmit: 'Sign up',
  logSubmit: 'Log in',
  regTitle: 'Sign up',
  logTitle: 'The entrance to the personal account',
  forgotLink: 'Forgot password?',
  password: 'Password',
  alternativeText: 'Or login with',
  regFooter: 'Already have an account?',
  logFooter: 'Don\'t have an account?',
  leaveToComplexes: 'Back to all projects',
  logOut: 'Log out',
  loadMore: 'Load more',
  loading: 'Loading',
  requiredField: 'This field required',
  invalidComplexShortName: 'Only english chars or numbers without special characters or spaces',
  addNew: 'Add new',

  // create project
  projectName: 'Project name',
  projectShortName: 'Project URL ending',
  projectStatus: 'Project status',
  projectAddress: 'Project address',
  projectCallBackCountryCode: 'Callback form country code',
  primaryLanguage: 'Primary language',
  systemPrimaryLanguage: 'System primary language',
  systemSecondaryLanguages: 'System secondary languages',
  secondaryLanguages: 'Secondary languages',
  adminPanelPrimaryLanguage: 'Admin panel primary language',
  adminPanelSecondaryLanguages: 'Admin panel secondary languages',
  websitePrimaryLanguage: 'Website primary language',
  websiteSecondaryLanguages: 'Website secondary languages',
  uploadProjectPreviewImage: 'Upload project preview image',
  uploadProjectLogo: 'Upload project logo',

  // project specification
  purchaseTerms: 'Purchase terms',
  propertyClass: 'Property class',
  salesStatus: 'Sales status',
  constructionPhase: 'Construction phase',
  completionDate: 'Completion date',

  //
  or: 'or',
  and: 'and',
  not: 'not',

  //
  restorePass: 'Restore password',
  varifyEmail: 'Verify email',
  confirmationCodeSentTo: 'A confirmation code was sent to',
  changePass: 'Change password',
  sendCode: 'Send code',
  resendCode: 'Re-send code',
  code: 'Code',
  newPass: 'New password',
  repeatNewPass: 'Repeat new password',
  resetPass: 'Reset password',

  photo: 'Photo',
  name: 'Name',
  role: 'Role',
  edit: 'Edit',
  set: 'Set',
  invite: 'Invite',
  title: 'Profile',
  logo: 'Logo',
  deactivate: 'Deactivate',
  complexesLink: 'Projects',
  project: 'Project',
  developer: 'Developer',
  usersLink: 'Users',
  createUser: 'CreateUser',
  editUser: 'Edit User',
  createNewUsers: 'Create New Users',
  manageUsersLink: 'Manage Users',
  manageProjectUsersLink: 'Manage project users',
  developersLink: 'Developers',
  marketplaceLink: 'Marketplaces',
  projectsLink: 'Your projects',
  createProject: 'Create a new project',
  exportAvailability: 'Export availability',
  projectEditing: 'Project editing',
  settingsLink: 'Admin settings',
  settings: 'Settings',
  managers: 'Managers',
  manager: 'Manager',
  admin: 'Admin',
  superadmin: 'Superadmin',
  supervisor: 'Supervisor',
  partner: 'Partner ',
  rootAdmin: 'Root Admin ',
  complexes: 'Complexes',
  statuses: 'Statuses',
  manageStatuses: 'Manage statuses',
  addStatus: 'Add status',
  logout: 'Logout',
  addProject: 'Add project',
  addDeveloper: 'Add developer',
  developerEditing: 'Developer editing',
  integration: 'Integration',
  mainData: 'Main data',
  chooseAnAction: 'Choose an action to get started',
  dealDataAccessManagementHeader: 'Deal Data Access Management',
  dealDataAccessManagementForManagers: 'Show deal data for managers (deal, responsible, client\'s name and phone number)',
  domainName: 'Domain name',
  funnelSettings: 'Funnel settings',
  addManager: 'Add manager',
  addComplex: 'Add complex',
  addStage: 'Add stage',
  generateStages: 'Generate stages',
  stageName: 'Stage name',
  stageId: 'Stage ID',
  notFoundComplexes: 'No residential complexes found',
  notFoundDevelopers: 'No developers found',
  saveChanges: 'Save changes',
  decode: 'Decode',
  goToStorage: 'Stock & buildings management',
  manageStock: 'Manage stock',
  successfullyUpdated: 'Successfully Updated',
  partiallyUpdated: 'Partially Updated',
  massiveError: 'Massive Error',
  storage: 'Stock',
  house: 'House',
  building: 'Building',
  buildingEditing: 'Edit building information',
  section: 'Section',
  floor: 'Floor',
  unit: 'Unit',
  unitNumber: 'Unit number',
  totalArea: 'Total area',
  layoutType: 'Layout type',
  mistake: 'Mistake',
  property: 'Property',
  oldValue: 'Old value',
  newValue: 'New value',
  openLogs: 'Open Logs',
  rollUpLog: 'Roll up log',
  seeLog: 'Updates logs',
  errorList: 'Errors list',
  updatesList: 'Updates list',
  listNewProps: 'List of newly created properties',
  logErrorHead: 'Please, pay attention to the changes that caused the error(s) below.',
  import: 'Import updated database',
  export: 'Export current database',
  exportThisVersion: 'Archived version',
  goBack: 'Return',
  crmAdminStatus: 'CRM/Admin panel',
  websiteStatus: 'Website',
  showOnWebsite: 'Show on website',
  typeAndPeriod: 'Type and period',
  replaceable: 'Replaceable',
  available: 'Availaible',
  managersSearchPlaceholder: 'Search by name or email',
  dealSearchPlaceholder: 'Search by deal ID, status, stage, actor…',
  statusSearchPlaceholder: 'Search by status',
  chooseComplexes: 'Choose complexes',

  // manager page (not all ^)
  editManager: 'Manager\'s update',
  addingManager: 'Adding manager',
  selectManagers: 'Select from existing managers',
  noManagersFound: 'No managers found',
  add: 'Add',

  // status page
  systemPlacement: 'System/Placement',
  colorInSystemPlacement: 'Color in System/Placement',
  colorInCross: 'Color in CRM/Admin panel',
  colorInWebsite: 'Color in website',
  nameInModule: 'Name in module',
  nameInCross: 'Name in crosstable',
  addingNewStatus: 'Adding new status',
  editingStatus: 'Editing status',
  type: 'Type',
  period: 'Period',
  hours: 'hours',
  managerCanChange: 'Manager can change',
  managerCanApply: 'Manager can apply',
  oneApartInDeal: 'One unit per deal',
  allowAttachUnitInDeal: 'Allow attach unit to the deal',
  canAttachUnitInDeal: 'Can attach to the deal',
  bindingRoomsWithStatus: 'Attach units with the status',

  // complex overview
  projectOverview: 'Project overview',
  estimatedCompletion: 'Estimated completion',
  unitsForSale: 'Units for sale',
  usersWithAccess: 'Users with access',

  // complex overview actions
  projectSettings: 'Project settings',

  // header
  changeView: 'Change view',
  simpleView: 'simple',
  listView: 'listing',
  detailedView: 'detailed',

  // appartment status
  chooseStatus: 'Choose a status',
  apartmentStatus: 'Unit status',
  status: 'Status',
  validUntil: 'Valid until',
  applyNewStatus: 'Apply the new status',
  apply: 'Apply',

  // deals
  attachUnitToDeal: 'Attach the unit to the deal',
  detachUnitFromDeal: 'Detach the unit from the deal',
  openDealInCRM: 'Open a deal in CRM',
  deleting: 'Deleting',
  updating: 'Updating',
  responsible: 'Responsible',
  client: 'Client',
  cancel: 'Cancel',
  detach: 'Detach',
  otherAttachedDeals: 'Other attached deals',
  otherLinkedDeals: 'Other linked deals',
  attachedDeals: 'Attached deals',
  disabledAttach: 'To attach this unit you need to detach another unit from this deal first',
  dialogTitle: 'Are you sure you want to detach the apartment',
  dialogContent: 'Before detaching, we recommend warning the user',

  // intergations
  attachedDealDetails: 'Attached deal details',
  responsibleUser: 'Responsible user',
  multipleResponsible: 'Multiple responsible',
  dealName: 'Deal name',

  // locations
  updateLocations: 'Update Location',
  latitude: 'Latitude',
  longitude: 'Longitude',
  countryManual: 'Country (manual)',
  cityManual: 'City (manual)',
  districtManual: 'District (manual)',
  nearestMetroStationManual: 'Nearest metro station (manual)',
  nearestMetroBranchManual: 'Station branch (manual)',
  nearestMetroWalkMinutesManual: 'Nearest station walk distance (manual)',
  nearestMetroDriveMinutesManual: 'Nearest station drive distance (manual)',
  countryAutoCalculated: 'Country (calculated)',
  cityAutoCalculated: 'City (calculated)',
  districtAutoCalculated: 'District (calculated)',
  nearestMetroStationAutoCalculated: 'Nearest metro station (calculated)',
  nearestMetroBranchAutoCalculated: 'Station branch (calculated)',
  nearestMetroWalkMinutesAutoCalculated: 'Nearest station walk distance (calculated)',
  nearestMetroDriveMinutesAutoCalculated: 'Nearest station drive distance (calculated)',

  // marketplace
  notFoundMarketplaces: 'No marketplaces found',
  marketplaceName: 'Marketplace Name',
  marketplaceShortName: 'Marketplace short Name',
  developers: 'Developers',
  addMarketplace: 'Create marketplace',
  marketplacesAndDevelopers: 'Marketplaces & developers',
  marketplaceEditing: 'Marketplace editing',
  marketplace: 'Marketplace',
  marketplaceSetUp: 'Marketplace set-up',
  marketplaceComponents: 'UI components display',
  projectsUnitToggle: 'Projects/Units Toggle',
  headerSettings: 'Header Settings',
  marketplaceLogo: 'Marketplace logo',
  headerTitle: 'Header title',
  favourites: 'Favourites',
  menu: 'Menu',

  // marketplace filters
  marketplaceFiltersLink: 'Filters',
  primarySelectionFilters: 'Primary selection filters',
  primarySelectionTags: 'Primary selection tags',
  secondaryFilters: 'Secondary filters',
  locationGroup: 'Location Group',
  elementsList: 'Elements List',
  selectElement: 'Select Element',
  selectContainer: 'Select Container',
  elementSortOrder: 'Element sort order',
  containerSortOrder: 'Container sort order',
  sortOrder: 'Sort Order',
  conversion: 'Conversion',
  addPrimaryTagGroup: 'Add another primary tag group',
  accordionState: 'Accordion state',
  callToAction: 'Call to action',
  chooseProperty: 'Choose property',
  chooseSpecificationProperty: 'Choose specification property',
  chooseGroupingProperty: 'Choose grouping property',
  chooseFirstDescriptionProperty: 'Choose 1st description property',
  chooseSecondDescriptionProperty: 'Choose 2nd description property',
  chooseValue: 'Choose value',
  fromNaming: 'From naming',
  toNaming: 'To naming',
  mainUOM: 'Main UOM (unit of measurement)',
  secondaryUOM: 'Secondary UOM',
  conversionRate: 'Conversion rate',
  informationalTegText: 'Informational Teg text',
  infoTag: 'Info tag',
  isNeedToChange: 'The previously selected value no longer exists. Please choose another value from the available options',

  // marketplace tiles
  projectsTitle: 'Projects tile',
  address: 'Address',
  unitsTitle: 'Units tile',
  projectsOrder: 'Projects order, gallery and tags',
  unitsOrder: 'Units order',
  groupingByProjects: 'Grouping by projects',
  unitsCard: 'Units card',
  unitsSortOrder: 'Unit’s sort order',
  unitsCardTags: 'Unit’s card tags',
  unitsCardTextBox: 'Unit’s card 1st header - text box',
  unitsCardMainSecondary: 'Unit’s card 1st header - text (main & secondary)',
  unitsCardHeaderWithDivider: 'Unit’s card 2nd header with divider',
  unitsCardAdditionalInfoWithDivider: 'Unit’s card additional info with divider',
  unitsCardIconsBlockOne: 'Unit’s card icons - Block 1',
  unitsCardIconsBlockTwo: 'Unit’s card icons - Block 2',
  unitsCardFooterDefault: 'Unit’s card footer - default - Project name, location, logo',
  unitsCardFooterHoverActions: 'Unit’s card footer - hover - actions',
  unitsCardFooterHoverDetails: 'Unit’s card footer - hover - details',
  nameValue: 'Name Value',
  propertyType: 'Property type',
  propertyName: 'Property name',
  propertyValue: 'Property value',
  newSortValue: 'New sort value',
  unitTag: 'Unit tag',
  textInBox: 'Text in box',
  headerWithDivider: '2nd header element with divider',
  additionalInfoWithDivider: 'Additional info element with divider',
  iconDescriptionElement: 'Icon description element',
  mainText: 'Main text',
  secondaryText: 'Secondary text',
  fontWeight: 'Font Weight',
  fontColor: 'Font Color',
  backgroundColor: 'Background Color',
  outlineColor: 'Outline Color',
  fontDecoration: 'Font Decoration',
  newSortText: 'Add and set up options you want to have for sorting:',
  AddAnotherUnitTag: 'Add another unit tag:',
  AddAnother1stHeaderElement: 'Add another 1st header element:',
  AddAnother2ndHeaderElement: 'Add another 2nd header element:',
  AddAnotherAdditionalInfoElement: 'Add another additional info element:',
  actionButtonName: 'Action button name',
  detailsButtonName: 'Details button name',
  isDefault: 'Is default',
  projectsDescription: 'Project description',
  additionalSettings: 'Additional settings',
  additionalSettingsTitle: 'Add default informational tag icon',
  editGallery: 'Edit Gallery',
  galleryImageUploadText: 'Upload gallery picture (JPEG format)',
  addProjectTileTags: 'Add project tile tags',
  enterTagText: 'Enter tag text',
  walkingDistance: 'Walking distance',
  drivingDistance: 'Driving distance',
  metroOrDistrict: 'Metro or district',
  prefix: 'Prefix',
  suffix: 'Suffix',
  availabilityCounterPrefix: 'Availability counter prefix',
  availabilityCounterSuffix: 'Availability counter suffix',
  uom: 'UOM',
  shorterDistanceOnly: 'Shorter distance only',
  locationDescription: 'Location section function based on data from project location details.\n'
    + '\n'
    + '            In this section, we need to choose which of the properties (metro station, district, or city) we would like to display.\n'
    + '            All properties  in the list will be displayed in the interface in their order. If there are no values for this property\n'
    + '            in the system (for example, no metro station specified), the second property from the list (e.g., district) will be displayed.\n'
    + '\n'
    + '            The metro station is associated with walking and driving distance values, which must be specified in the project\n'
    + '            location details as well. You may choose to show only the shorter distance, either walking or driving, based\n'
    + '            on the minimum value. For instance, if this option is enabled and the walking distance is 25 minutes while the driving\n'
    + '            distance is 5 minutes, the system will display the driving distance for this particular project because 5 less than 25.',
  districtDescription: 'При включеному селекторі система буде виводити в інтерфейс одне з двух значень. Або станцію метро, або район. Тобто при увімкненому селекторі ми побачимо або метро або район.\n'
    + '                      Що саме буде показано в інтерфейсі в такому разі залежить від порядку в якому ці параметри відсортовані в списку вище, а також який з параметрів має значення в системі.\n'
    + '                      Якщо на першому місці стоїть метро, але його значення немає в системі, то в інтерфейсі буде виведено район.\n'
    + '                      Якщо ж цей серектор вимнений, то в інтерфейсі відображаються обидва параметри - і метро, і район в тому порядку сортування як вони відсортовані нижче.',

  // availability report
  selectProjectToBeDisplayed: 'Select project to be displayed in availability report',
  roundingMethod: 'Rounding method',
  thousandsSeparator: 'Thousands separator',
};
